export const aiQueryKeys = {
  cvAiUsage: ['cv-ai-usage'] as const,
  cvAiCareerHistory: ['cv-ai-career-history'] as const,
  cvAiSuggestHistory: ['cv-ai-suggest-history'] as const,
} as const;
